import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system"

const variants = {
  info: {
    backgroundColor: "black",
    color: "white",
    borderRadius: "4px",
    px: 3,
    py: 1,
  },
  sticker: {
    backgroundColor: "rgba(0,0,0,0.7)",
    color: "white",
    borderWidth: "1px",
    borderColor: "#9D9999",
    rounded: "full",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};

export const Badge = defineStyleConfig({
  variants,
});
